import React from 'react';
import Button from '../../../../../../components/Button';
import ContainerPage from '../../../../../../components/ContainerPage';
import * as S from './styles';

const doctorIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/illustrations/doctor-initial-assessments.svg';
const ArrowLeft = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Voltar.svg';

export type CheckupDigitalDetailsProps = {
  onClose?: () => void;
  handleContinue: () => void;
};

export const CheckupDigitalDetailsWithoutExams = ({ onClose, handleContinue }: CheckupDigitalDetailsProps) => {
  const [hasUploadedExamAccepted, setHasUploadedExamAccepted] = React.useState(false);

  return (
    <ContainerPage
      childrenFooter={
        <Button title="Continuar agendamento" disabled={!hasUploadedExamAccepted} onClick={handleContinue} />
      }
    >
      <S.CloseWrapper>
        <div onClick={onClose}>
          <S.CloseIcon src={ArrowLeft} alt="Close Icon" />
          <S.CloseTitle>Voltar</S.CloseTitle>
        </div>
      </S.CloseWrapper>
      <S.Container>
        <img className="main-icon" src={doctorIcon} alt="warning" />
        <h3 className="title">Consultas complementares</h3>
        <p className="subtitle">
          Não esqueça de enviar os resultados dos seus exames na funcionalidade <strong>“Resultado de Exames”</strong>{' '}
          disponível no app Meu Einstein. Caso já tenha realizado o envio, confirme abaixo para continuar com o
          agendamento.
          <br></br>
          <br></br>
          Você tem o prazo de 90 (noventa) dias para realizar as consultas.
        </p>
        <S.CheckWrapper>
          <S.CustomCheck
            label="Afirmo que já realizei o envio dos resultados dos exames solicitados."
            labelDirection="right"
            checked={hasUploadedExamAccepted}
            onChange={() => setHasUploadedExamAccepted(accepted => !accepted)}
          />
        </S.CheckWrapper>
      </S.Container>
    </ContainerPage>
  );
};
